module.exports = __webpack_public_path__ + "static/media/icon_custom_location_type_generic_purple.4e6bf76e.svg";